import React from 'react';

const BannerImage = () => {
    return (
        <a href="#" className="banner-image-wrapper br-4">
            <img src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png" alt="banner" className="image br-4"/>
        </a>
    );
};

export default BannerImage;
